import Dialog, {
  DialogProps,
} from '$tablet-app/src/app/components/Dialog/Dialog';
import DialogBottomActions from '$tablet-app/src/app/components/Dialog/DialogBottomActions';
import { MealPlanPreferences } from '$tablet-app/src/app/recipes/types';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import { MealPreferencesDialogView } from './store/types';
import { useMealPreferenceDialogState } from './store/useMealPreferenceDialogState';
import PreferencesViewSwitch from './views/PreferencesViewSwitch';

interface Props extends DialogProps {
  onSubmitDone?: (preferences: MealPlanPreferences) => void;
}

const MealPlanPreferencesDialog = ({ onSubmitDone }: Props) => {
  const visible = useMealPreferenceDialogState((state) => state.visible);

  const view = useMealPreferenceDialogState((state) => state.view);

  const close = useMealPreferenceDialogState(
    (state) => state.closePreferencesDialog
  );

  const cancel = useMealPreferenceDialogState(
    (state) => state.cancelEditingPreference
  );

  const savePreference = useMealPreferenceDialogState(
    (state) => state.submitPreference
  );

  const preferences = useMealPreferenceDialogState(
    (state) => state.preferences
  );

  const onPressDone = () => {
    if (view === 'main') {
      onSubmitDone?.(preferences);
      close();
    } else {
      savePreference();
    }
  };

  return (
    <Dialog visible={visible} onClose={close} size="mc">
      <Title variant="h3" weight="bold">
        {titles[view]}
      </Title>

      <PreferencesViewSwitch view={view} />

      <BottomActions>
        <Button variant="text" onPress={view === 'main' ? close : cancel}>
          Cancel
        </Button>

        <Button onPress={onPressDone}>Done</Button>
      </BottomActions>
    </Dialog>
  );
};

const Title = styled(Text)`
  padding: 30px 16px 5px;
  text-align: center;
  font-size: 24px;
`;

const BottomActions = styled(DialogBottomActions)`
  gap: 16px;
`;

const titles: Record<MealPreferencesDialogView, string> = {
  main: 'Create your meal plan',
  diet_balance: 'Dietary balance',
  allergies: 'Allergies',
  avoidances: 'Things to avoid',
  time_and_effort: 'Time and effort',
  budget: "What's your budget for meals?",
  people: 'How many people are we cooking for on a typical day',
  eats_meat: 'Would you like meat in your recipes?',
  meat_types: 'Which meat types would you like?',
  meals_to_plan: 'What meals would you like to be planned?',
  reminders: 'Reminders',
};

export default MealPlanPreferencesDialog;
